import { render, staticRenderFns } from "./WalletBalance.vue?vue&type=template&id=7a27ff63&scoped=true"
import script from "./WalletBalance.vue?vue&type=script&lang=js"
export * from "./WalletBalance.vue?vue&type=script&lang=js"
import style0 from "./WalletBalance.vue?vue&type=style&index=0&id=7a27ff63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a27ff63",
  null
  
)

export default component.exports